import { LuChevronDown } from "react-icons/lu";
import * as styled from "./DropDown.styled";

// value — обране значення (показуємо його), placeholder — підказка, поки нічого не обрано
function DropDown({ setOpen, value, placeholder, open, disabled }) {
  return (
    <styled.TopWrapper type="button" onClick={() => !disabled && setOpen((prev) => !prev)} $open={open} disabled={disabled}>
      <styled.TopTitle $placeholder={!value}>{value || placeholder}</styled.TopTitle>
      <LuChevronDown size={20} />
    </styled.TopWrapper>
  );
}

export default DropDown;
